import React from 'react'
import StatusLight from '../../../components/Status/StatusLight'

const AppointmentSingleServiceProvidedStatusRenderer = (props) => {
  return <StatusLight status='success' size='16px' />
}

export default AppointmentSingleServiceProvidedStatusRenderer
